module.exports = __webpack_public_path__ + "static/media/03.59c74764.png";